import React, {Fragment} from 'react';
import {Button, Modal} from "antd";
import {MODAL_WIDTH_MD, MODAL_WIDTH_SM} from "../../../styles/constants";
import DataflowsList from "./List";
import {compose} from "redux";
import {translate} from 'react-i18next';
import DataflowDetail from "./Detail";
import {
  changeDataflowsDataflowClone,
  changeDataflowsDataflowDownload,
  changeDataflowsDataflowExport,
  hideDataflowsDataflowClone,
  hideDataflowsDataflowDownload,
  hideDataflowsDataflowExport,
  hideDataflowsDataflowExportReport,
  submitDataflowsDataflowClone,
  submitDataflowsDataflowDownload,
  submitDataflowsDataflowExport
} from "./actions";
import {connect} from "react-redux";
import ArtefactDownloadForm from "../../../components/artefact-download-form";
import EnhancedModal from "../../../components/enhanced-modal";
import {
  ARTEFACT_TYPE_DATAFLOW,
  ARTEFACT_TYPE_MULTIPLE,
  DOWNLOAD_FORMAT_TYPE_CSV,
  getArtefactDownloadOptions
} from "../../../constants/download";
import ArtefactExportForm from "../../../components/artefact-export-form";
import ArtefactExportReport from "../../../components/artefact-export-report";
import {isCloneDestTripletValid, isExportDestinationValid} from "../../../utils/artefactValidators";
import ArtefactCloneForm from "../../../components/artefact-clone-form";
import {getStringFromArtefactTriplet} from "../../../utils/sdmxJson";

const mapStateToProps = state => ({
  endpoints: state.config.nodes,
  endpointId: state.app.endpointId,
  dataLanguages: state.config.dataManagement.dataLanguages,
  dataflow: state.scenes.metaManager.dataflows.dataflow,
  allAgencies: state.scenes.metaManager.dataflows.allAgencies,
  downloadDataflowTriplets: state.scenes.metaManager.dataflows.downloadDataflowTriplets,
  downloadDataflowLang: state.scenes.metaManager.dataflows.downloadDataflowLang,
  downloadDataflowParams: state.scenes.metaManager.dataflows.downloadDataflowParams,
  cloneDestTriplet: state.scenes.metaManager.dataflows.cloneDestTriplet,
  dataflowExportSourceTriplet: state.scenes.metaManager.dataflows.dataflowExportSourceTriplet,
  dataflowExportDestination: state.scenes.metaManager.dataflows.dataflowExportDestination,
  dataflowExportReport: state.scenes.metaManager.dataflows.dataflowExportReport,
  user: state.app.user
});

const mapDispatchToProps = dispatch => ({
  onDownloadHide: () => dispatch(hideDataflowsDataflowDownload()),
  onDownloadChange: fields => dispatch(changeDataflowsDataflowDownload(fields)),
  onDownloadSubmit: (artefactTriplet, downloadDataflowParams, lang) =>
    dispatch(submitDataflowsDataflowDownload(artefactTriplet, downloadDataflowParams, lang)),
  onCloneHide: () => dispatch(hideDataflowsDataflowClone()),
  onCloneChange: fields => dispatch(changeDataflowsDataflowClone(fields)),
  onCloneSubmit: (cloneDestTriplet, srcDataflow, annotationsConfig) =>
    dispatch(submitDataflowsDataflowClone(cloneDestTriplet, srcDataflow, annotationsConfig)),
  onExportHide: () => dispatch(hideDataflowsDataflowExport()),
  onExportChange: fields => dispatch(changeDataflowsDataflowExport(fields)),
  onExportSubmit: (sourceTriplets, destination) => dispatch(submitDataflowsDataflowExport(sourceTriplets, destination)),
  onExportReportHide: () => dispatch(hideDataflowsDataflowExportReport())
});

const Dataflows = ({
                     t,
                     endpoints,
                     endpointId,
                     dataLanguages,
                     dataflow,
                     allAgencies,
                     downloadDataflowTriplets,
                     downloadDataflowLang,
                     downloadDataflowParams,
                     onDownloadHide,
                     onDownloadChange,
                     onDownloadSubmit,
                     cloneDestTriplet,
                     onCloneHide,
                     onCloneChange,
                     onCloneSubmit,
                     dataflowExportSourceTriplet,
                     dataflowExportDestination,
                     onExportHide,
                     onExportChange,
                     onExportSubmit,
                     dataflowExportReport,
                     user,
                     onExportReportHide
                   }) =>
  <Fragment>
    <DataflowsList/>
    <DataflowDetail/>
    <EnhancedModal
      visible={downloadDataflowTriplets !== null && downloadDataflowTriplets !== undefined}
      onCancel={onDownloadHide}
      footer={
        <div>
          <Button onClick={onDownloadHide}>
            {t('commons.buttons.close.title')}
          </Button>
          <Button
            onClick={
              () => onDownloadSubmit(downloadDataflowTriplets, downloadDataflowParams, downloadDataflowLang)
            }
            type="primary"
            disabled={
              (downloadDataflowParams && downloadDataflowParams.format === null) ||
              (downloadDataflowParams && downloadDataflowParams.format === DOWNLOAD_FORMAT_TYPE_CSV &&
                (
                  downloadDataflowParams.csvSeparator === null ||
                  downloadDataflowParams.csvSeparator.length !== 1 ||
                  downloadDataflowParams.csvLanguage === null
                ))
            }
          >
            {t('commons.buttons.download.title')}
          </Button>
        </div>
      }
      width={MODAL_WIDTH_SM}
      title={
        downloadDataflowTriplets && downloadDataflowTriplets.length > 1
          ? t('scenes.metaManager.commons.modals.download.titleMulti')
          : t('scenes.metaManager.commons.modals.download.title', {
            triplet: downloadDataflowTriplets
              ? getStringFromArtefactTriplet(downloadDataflowTriplets[0])
              : ""
          })
      }
    >
      <ArtefactDownloadForm
        downloadArtefactForm={downloadDataflowParams}
        onChange={onDownloadChange}
        options={getArtefactDownloadOptions(
          t,
          (downloadDataflowTriplets && downloadDataflowTriplets.length > 1)
            ? ARTEFACT_TYPE_MULTIPLE
            : ARTEFACT_TYPE_DATAFLOW
        )}
        langs={dataLanguages}
        hasReferences
      />
    </EnhancedModal>
    <EnhancedModal
      visible={cloneDestTriplet !== null}
      width={MODAL_WIDTH_MD}
      title={t('commons.artefact.modals.clone.title')}
      onCancel={onCloneHide}
      footer={
        <div>
          <Button onClick={onCloneHide}>
            {t('commons.buttons.close.title')}
          </Button>
          <Button
            onClick={() => {
              if (!isCloneDestTripletValid(cloneDestTriplet)) {
                Modal.warning({
                  title: t('commons.alerts.invalidForm.title'),
                  content: t('commons.alerts.invalidForm.content')
                });
              } else {
                onCloneSubmit(cloneDestTriplet, dataflow, endpoints.find(endpoint => endpoint.general.id === endpointId).annotations);
              }
            }}
            type="primary"
          >
            {t('commons.artefact.modals.clone.buttons.submit.title')}
          </Button>
        </div>
      }
    >
      <ArtefactCloneForm
        agencies={allAgencies}
        srcArtefact={dataflow}
        destTriplet={cloneDestTriplet}
        onChange={onCloneChange}
      />
    </EnhancedModal>
    <EnhancedModal
      visible={dataflowExportSourceTriplet !== null}
      title={t('commons.artefact.modals.export.title')}
      width={MODAL_WIDTH_MD}
      onCancel={onExportHide}
      footer={
        <div>
          <Button onClick={onExportHide}>{t('commons.buttons.close.title')}</Button>
          <Button
            type="primary"
            onClick={() => {
              if (isExportDestinationValid(dataflowExportDestination, (user && user.providerId) !== null)) {
                onExportSubmit(dataflowExportSourceTriplet, dataflowExportDestination)
              } else {
                Modal.warning({
                  title: t('commons.alerts.invalidForm.title'),
                  content: t('commons.alerts.invalidForm.content')
                });
              }
            }}
          >
            {t('commons.artefact.modals.export.buttons.submit.title')}
          </Button>
        </div>
      }
    >
      <ArtefactExportForm
        type='dataflow'
        agencies={allAgencies}
        sourceTriplet={dataflowExportSourceTriplet}
        destination={dataflowExportDestination}
        onChange={onExportChange}
      />
    </EnhancedModal>
    <EnhancedModal
      visible={dataflowExportReport !== null}
      title={t('commons.artefact.modals.exportReport.title')}
      width={MODAL_WIDTH_MD}
      onCancel={onExportReportHide}
      footer={<Button onClick={onExportReportHide}>{t('commons.buttons.close.title')}</Button>}
    >
      <ArtefactExportReport
        report={dataflowExportReport}
      />
    </EnhancedModal>
  </Fragment>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(Dataflows);



// WEBPACK FOOTER //
// ./src/scenes/meta-manager/dataflows/index.jsx